import { render } from "./InputEmail.vue?vue&type=template&id=48854320&scoped=true"
import script from "./InputEmail.vue?vue&type=script&lang=ts"
export * from "./InputEmail.vue?vue&type=script&lang=ts"

import "./InputEmail.vue?vue&type=style&index=0&id=48854320&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48854320"

export default script